import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const inViewProps = (onLoad = false) =>
  onLoad ? { initial: "hidden", animate: "show" } : { initial: "hidden", whileInView: "show", viewport: { once: true, margin: "-8% 0px" } };

export const maskChild = (delay = 0, duration = 1.1) => ({
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration, delay, ease: EASE } },
});

export const MaskLine = ({ children, delay = 0, className = "", onLoad = false }) => (
  <motion.span className="block overflow-hidden pb-[0.08em]" {...inViewProps(onLoad)}>
    <motion.span className={`block ${className}`} variants={maskChild(delay)}>
      {children}
    </motion.span>
  </motion.span>
);

export const Reveal = ({ children, delay = 0, y = 40, className = "", as = "div", ...rest }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y, filter: "blur(10px)" }}
      whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const SectionLabel = ({ index, children }) => (
  <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-smoke">
    <span className="text-acid">({index})</span>
    <span className="h-px w-10 bg-line" />
    {children}
  </p>
);
